import { FC, ReactNode } from 'react';
import { Stack } from '@mui/material';
import { createUseStyles } from 'react-jss';

interface Props {
  children: ReactNode;
}

const useStyles = createUseStyles({
  pageTools: {
    '& button.MuiButtonBase-root': {
      whiteSpace: 'nowrap',
    },
  },
});

const PageTools: FC<Props> = ({ children }) => {
  const styles = useStyles();
  return (
    <Stack direction="row" justifyContent="flex-end" flexGrow={1} className={styles.pageTools}>
      {children}
    </Stack>
  );
};

export default PageTools;
